import { useState } from "react";
import { useData } from "../context/DataContext";
import { C, G } from "../styles/theme";
import { IMG } from "../data/initialData";
import FImg from "../components/common/FImg";
import Fld from "../components/common/Fld";
import PBtn from "../components/common/PBtn";

export default function Contact() {
  const { saveDB } = useData();
  const [cf, setCF] = useState({ name: "", phone: "", email: "", service: "Staffing Solutions", message: "" });
  const [sent, setSent] = useState(false);
  const fv = k => v => setCF(f => ({ ...f, [k]: v }));

  const submit = () => {
    if (!cf.name.trim() || !cf.email.trim()) { alert("Please fill Name and Email."); return; }
    saveDB("leads", { ...cf, id: null, company: "", status: "new", date: new Date().toISOString().slice(0, 10) });
    setSent(true);
  };

  return (
    <div style={{ background: C.bg }}>
      <div style={{ background: G.hero, padding: "44px 24px 36px", textAlign: "center" }}>
        <span style={{ color: C.orange2, fontSize: 11, fontWeight: 700, letterSpacing: 1, textTransform: "uppercase" }}>Get In Touch</span>
        <h1 style={{ fontFamily: "'Playfair Display',Georgia,serif", fontSize: 30, fontWeight: 800, color: "#fff", margin: "11px 0 9px", letterSpacing: "-0.4px" }}>Let's Start a Conversation</h1>
        <p style={{ color: "rgba(255,255,255,.65)", fontSize: 14 }}>Our team responds within 1 business day.</p>
      </div>
      <div style={{ padding: "48px 24px" }}>
        <div className="grid-2" style={{ maxWidth: 1080, margin: "0 auto", gap: 40, alignItems: "start" }}>
          <div>
            <FImg src={IMG.office} h={190} style={{ width: "100%", height: 190, objectFit: "cover", borderRadius: 13, marginBottom: 18 }} />
            <div style={{ background: "linear-gradient(135deg,#0f2344,#1A3C6E)", borderRadius: 13, padding: "18px 18px", marginBottom: 14 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: C.orange2, marginBottom: 11, letterSpacing: .4, textTransform: "uppercase" }}>Our Offices</div>
              {[["Head Office", "Bijnor, Uttar Pradesh"], ["Branch Office", "New Delhi"], ["Branch Office", "Mumbai, Maharashtra"]].map(([t, l]) => (
                <div key={l} style={{ display: "flex", gap: 8, marginBottom: 10, alignItems: "flex-start" }}>
                  <span style={{ fontSize: 16, flexShrink: 0 }}>🏢</span>
                  <div><div style={{ fontSize: 10, color: "rgba(255,255,255,.38)", fontWeight: 700, textTransform: "uppercase", letterSpacing: .3 }}>{t}</div><div style={{ fontSize: 13, color: "rgba(255,255,255,.84)", marginTop: 1 }}>{l}</div></div>
                </div>
              ))}
            </div>
            {[["📞", "+91-7977779135"], ["✉️", "info@cyclojetinfotech.com"], ["🕐", "Mon – Sat, 9:00 AM – 6:30 PM IST"]].map(([ic, tx]) => (
              <div key={tx} style={{ display: "flex", gap: 10, marginBottom: 11, alignItems: "center" }}><span style={{ fontSize: 18, width: 24 }}>{ic}</span><span style={{ fontSize: 13.5, color: C.dark }}>{tx}</span></div>
            ))}
          </div>
          <div style={{ background: "#fff", borderRadius: 14, padding: 28, boxShadow: "0 8px 28px rgba(26,60,110,.1)", border: `1px solid ${C.border}` }}>
            {sent ? (
              <div style={{ textAlign: "center", padding: "34px 0" }}>
                <div style={{ width: 68, height: 68, background: "#dcfce7", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 28, margin: "0 auto 14px" }}>✅</div>
                <h3 style={{ color: C.blue, marginBottom: 7, fontSize: 19 }}>Thank You!</h3>
                <p style={{ color: C.gray, marginBottom: 20, lineHeight: 1.7 }}>Your message has been received. We will be in touch within 1 business day.</p>
                <PBtn onClick={() => setSent(false)}>Send Another Message</PBtn>
              </div>
            ) : (
              <>
                <h3 style={{ fontSize: 19, fontWeight: 800, color: C.blue, marginBottom: 4 }}>Send Us a Message</h3>
                <p style={{ fontSize: 13, color: C.gray, marginBottom: 18, lineHeight: 1.6 }}>Fill in the form and our team will get back to you promptly.</p>
                <div className="grid-2" style={{ gap: 11 }}>
                  <Fld label="Full Name" value={cf.name} onChange={fv("name")} />
                  <Fld label="Phone Number" value={cf.phone} onChange={fv("phone")} />
                </div>
                <Fld label="Email Address" value={cf.email} onChange={fv("email")} type="email" />
                <Fld label="Service Required" value={cf.service} onChange={fv("service")} opts={["Staffing Solutions", "Software Development", "Cloud Computing", "Cybersecurity", "Data Analytics & AI", "IT Support", "Digital Marketing", "Cyclojet Lab – Product Enquiry", "Cyclojet Lab – Bulk Order", "Valuation Services", "Other"]} />
                <Fld label="Your Message" value={cf.message} onChange={fv("message")} rows={4} />
                <PBtn onClick={submit} full extra={{ marginTop: 4 }}>Send Message</PBtn>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
